import { connect } from 'react-redux';

import SeoTags from './SeoTags';

const mapStateToProps = (state) => {
    const {
        Global: { name },
    } = state;

    return { name };
};

export default connect(mapStateToProps, {})(SeoTags);
